/**
 * Tap toggle for the birthday card's hover-equivalent image darken/blur.
 * Desktop mouse hover is handled entirely in CSS (see
 * rewards-birthday-input.css); mobile has no hover capability at all, so
 * without this the blur/darken effect never showed there.
 *
 * Unlike rewards-levels.js / rewards-refer-faq.js, there's no toggle button
 * or hidden "before" content here — the Yotpo widget itself is always
 * visible on top of the image, so this only needs to add/remove a class
 * that darkens the image underneath; it never blocks or intercepts clicks
 * meant for the widget's own inputs/buttons.
 */
(function () {
  function closeCard(card) {
    card.classList.remove('is-revealed');
  }

  function openCard(card) {
    card.classList.add('is-revealed');
  }

  document.addEventListener('click', function (event) {
    // Ignore Yotpo's own submit/close buttons - otherwise submitting the
    // birthday form (itself a click "inside the card", like any other tap)
    // immediately toggles is-revealed back OFF right as the confirmation
    // message needs to show, un-hiding the collapsed tile's "When can we
    // celebrate you?" text at the exact moment it overlaps with "Yay!
    // You're on the guest list!" (confirmed live via screen recording,
    // 2026-08-19). Every other click inside the card still toggles
    // normally - this only carves out the two buttons that represent
    // "the user is done/leaving", not "the user wants to close this".
    if (event.target.closest('.yotpo-filled-button, .yotpo-widget-campaign-widget-close-button')) return;

    var card = event.target.closest('.rewards-birthday-input__card');
    var openCards = document.querySelectorAll('.rewards-birthday-input__card.is-revealed');

    openCards.forEach(function (openCard) {
      if (openCard !== card) closeCard(openCard);
    });

    if (card) {
      if (card.classList.contains('is-revealed')) {
        closeCard(card);
      } else {
        openCard(card);
      }
    }
  });
})();
